__turbopack_context__.v({
  "feature": "Landing-module__QrMDlq__feature",
  "featureIcon": "Landing-module__QrMDlq__featureIcon",
  "featureText": "Landing-module__QrMDlq__featureText",
  "featureTitle": "Landing-module__QrMDlq__featureTitle",
  "features": "Landing-module__QrMDlq__features",
  "hero": "Landing-module__QrMDlq__hero",
  "heroButtons": "Landing-module__QrMDlq__heroButtons",
  "heroIcon": "Landing-module__QrMDlq__heroIcon",
  "heroSubtitle": "Landing-module__QrMDlq__heroSubtitle",
  "heroTitle": "Landing-module__QrMDlq__heroTitle",
  "page": "Landing-module__QrMDlq__page",
  "primaryButton": "Landing-module__QrMDlq__primaryButton",
  "secondaryButton": "Landing-module__QrMDlq__secondaryButton",
  "topBar": "Landing-module__QrMDlq__topBar",
});
